import { get, post, put, remove } from '../infrastructure/webRequest';

export type CitySite = {
  active: boolean;
  created_at: string;
  format: {
    height: number;
    id: string;
    width: number;
  };
  id: string;
  latitude: string;
  longitude: string;
  name: string;
  price: number;
};

export type CitySites = Array<CitySite>;

export const getSitesV1 = (cityId: string) =>
  get<CitySites>(`/v1/partner/cities/${cityId}/video/sites`);

export type CreateCitySiteRequest = {
  format_id: string;
  latitude: string;
  longitude: string;
  name: string;
  price: number;
};

export const createSiteV1 = (cityId: string, request: CreateCitySiteRequest) =>
  post(`/v1/partner/cities/${cityId}/video/sites`, request);

export type UpdateCitySiteRequest = CreateCitySiteRequest & {
  active: boolean;
  id: string;
};

export const updateSiteV1 = (cityId: string, request: UpdateCitySiteRequest) =>
  put(`/v1/partner/cities/${cityId}/video/sites`, request);

export const deleteSiteV1 = (cityId: string, id: string) =>
  remove(`/v1/partner/cities/${cityId}/video/sites`, { params: { id } });
